import React from 'react';
import { AfiClass } from '../../../models/afi';
import { AFI_CLASSES, getAFIClass } from '../../constants/afi';
import styles from './AFIScoreBadge.module.scss';

interface AFIScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

const AFIScoreBadge: React.FC<AFIScoreBadgeProps> = ({
  score,
  size = 'md',
  showLabel = false,
}) => {
  const afiClass: AfiClass = getAFIClass(score);
  const { color, bg, borderColor, label } = AFI_CLASSES[afiClass];

  const badgeStyle: React.CSSProperties = {
    backgroundColor: bg,
    borderColor: borderColor,
    color: color,
  };

  const progressBarStyle: React.CSSProperties = {
    width: `${Math.min(100, Math.max(0, score))}%`,
    backgroundColor: color,
  };

  if (size === 'sm') {
    return (
      <span
        className={`${styles.badge} ${styles.sm}`}
        style={badgeStyle}
        title={`AFI ${score} — ${label}`}
      >
        {score}
      </span>
    );
  }

  return (
    <span
      className={`${styles.badge} ${styles[size]}`}
      style={badgeStyle}
      title={`AFI ${score} — ${label}`}
    >
      <span className={styles.progressTrack}>
        <span className={styles.progressFill} style={progressBarStyle} />
      </span>
      <span className={styles.scoreText}>{score}</span>
      {showLabel && (
        <span className={styles.labelText}>{label}</span>
      )}
    </span>
  );
};

export default AFIScoreBadge;
